import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { signal } from "@preact-signals/safe-react";
import { CenterPopup, Toast } from "antd-mobile";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { collectApi } from "../../api/collect-api";
import { companyApi } from "../../api/company";
import { contractApi } from "../../api/contract-api";
import { financeApi } from "../../api/finance-api";
import { homeApi } from "../../api/home-api";
import { userApi } from "../../api/user-api";
import { WSContext } from "../../router/router";
import { convertToSeconds, getText } from "../../utils/util";
import CoinPopup from "./components/coinpopup";
import DaoJiShi from "./components/daojishi";
import KineCenter from "./components/kinecenter";
import OrderPopup from "./components/orderpopup";
import TopBar from "./components/topbar";
import TopText from "./components/topText";
import { useGoldData } from "@/utils/use-gold-data";

export const setIsShowOrderSignal = signal<any>();

export default function Trade() {
  const uid = localStorage.getItem("uid");
  const { t: translate } = useTranslation();
  // const [changeDaoJiShi, setChangeDaoJiShi] = useState(false);
  const [daojishi, setDaojis] = useState(60);
  const [timeindex, settimeindex] = useState(1);
  const [sendData, setSendData] = useState({});
  const [index, setIndex] = useState(3);
  const [isShowCoin, setIsShowCoin] = useState(false);
  const [isShowOrder, setIsShowOrder] = useState(false);
  const [nowTab, setNowTab] = useState("");
  const [successOrderNo, setsuccessOrderNo] = useState("");
  const [hysetInfo, setHysetInfo] = useState({});
  const [userInfo, setuserInfo] = useState({} as any);
  const [ctmarketlist, setCtmarketlist] = useState([] as any[]);
  const [collectlist, setcollectlist] = useState([] as any[]);
  const param = useParams();
  const [coinListData, setCoinListData] = useContext(WSContext);
  const [userInfoData, setUserInfoData] = useState({});
  const [hyorders, sethyorders] = useState([] as any[]);
  const [iscollect, setiscollect] = useState(false);
  let timer: any;
  const [companyData, setCompanyData] = useState({} as any);
  //贸易
  const [type, setType] = useState(1);
  //倒计时显示
  const [visible, setVisible] = useState(false);
  //预期收益
  const [yqsy, setyqsy] = useState(0);
  //初始化获取公司
  async function initCompany() {
    const res = await companyApi.domain();
    if (res.ok) {
      setCompanyData(res.data);
    }
  }

  useEffect(() => {
    setIsShowOrderSignal.value = setIsShowOrder;
  }, []);

  //用户信息
  const loadUserInfoData = async () => {
    const data = await userApi.userInfo();
    if (data.ok) {
      setUserInfoData(data.data);
    }
  };
  //加载数 据
  const loadhyorderData = async () => {
    const data = await contractApi.gethyorder({ uid });
    if (data.ok) {
      sethyorders(data.data);
    }
  };
  const loadctmarketlistData = async () => {
    const data = await homeApi.ctmarketlist({ pageNum: 1, pageSize: 100 });
    if (data.ok) {
      const list = data.data.records;
      list.sort((d, e) => d.sort - e.sort);
      setCtmarketlist(list);
    }
  };

  const loadcollectlistData = async () => {
    const data = await collectApi.list({ uid, pageNum: 1, pageSize: 100 });
    if (data.ok) {
      setcollectlist(data.data);
    }
  };
  const loadiscollectData = async () => {
    const data = await collectApi.sel({ uid, coinname: param.name });
    if (data.ok) {
      if (data.data) {
        setiscollect(true);
      } else {
        setiscollect(false);
      }
    }
  };

  const collectAdd = async () => {
    const data = await collectApi.add({ uid, coinname: param.name });
    if (data.ok) {
      Toast.show(translate(getText("添加自选成功")));
    }
    loadiscollectData();
  };

  const collectDel = async () => {
    const data = await collectApi.del({ uid, coinname: param.name });
    if (data.ok) {
      Toast.show(translate(getText("取消自选成功")));
    }
    loadiscollectData();
  };

  //加载数 据
  const loadUserCoinData = async () => {
    const data = await financeApi.userCoin({ uid });
    if (data.ok) {
      setuserInfo(data.data);
    }
  };

  //合约设置
  const loadhysetInfoData = async () => {
    const data = await contractApi.hysetInfo();
    if (data.ok) {
      let hysetInfoT = data.data;
      let hyTimes = hysetInfoT?.hyTime.split(",");
      let hyTzeds = hysetInfoT?.hyTzed.split(",");
      let hyYkbls = hysetInfoT?.hyYkbl.split(",");
      for (let index = 0; index < hyTimes.length; index++) {
        let hyTime = hyTimes[index];
        let hyTzed = hyTzeds[index];
        let hyYkbl = hyYkbls[index];
        hyTimes[index] = hyTime;
        hyTzeds[index] = parseInt(hyTzed);
        hyYkbls[index] = parseInt(hyYkbl);
      }
      hysetInfoT.hyTime = hyTimes;
      hysetInfoT.hyTzed = hyTzeds;
      hysetInfoT.hyYkbl = hyYkbls;
      setHysetInfo(hysetInfoT);
    }
  };

  //下单
  const buyCoin = async (dataInfo) => {
    dataInfo.uid = uid;
    //时间转化
    const time = convertToSeconds(dataInfo?.ctime);
    setDaojis(time);
    setSendData(dataInfo);
    const data = await contractApi.creatorder(dataInfo);
    if (data.ok) {
      Toast.show({ content: data.msg });
      //设置成功orderno
      setsuccessOrderNo(data.data);
      //开始倒计时
      // setChangeDaoJiShi(true);
      setIndex(1);
      setIsShowOrder(false);
      setVisible(true);
    } else {
      Toast.show({ content: data.msg });
    }
    loadData();
  };

  const loadData = async () => {
    loadcollectlistData();
    loadUserCoinData();
    loadhyorderData();
    loadiscollectData();
  };
  useEffect(() => {
    initCompany();
    setIndex(1);
  }, []);
  useEffect(() => {
    setNowTab(param.name);
  }, [param]);

  useEffect(() => {
    loadhyorderData();
    // setChangeDaoJiShi(false);
  }, [index]);
  useEffect(() => {
    loadhysetInfoData();
    loadctmarketlistData();
    loadData();
    timer = setInterval(() => {
      loadData();
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, [nowTab]);
  useEffect(() => {
    loadUserInfoData();
  }, []);
  
  useGoldData()

  return (
    <div className="flex flex-col min-h-screen bg-neutral-900 text-white revert-style">
      <AcendexLayout bottomBarIndex={3} theme="light">
        {isMobile ? (
          <>
            <div className="w-full">
              <TopBar
                coinname={param.name}
                iscollect={iscollect}
                collectAdd={collectAdd}
                collectDel={collectDel}
              />
            </div>

            <div className="bg-neutral-800 rounded-lg mx-2 my-2 shadow-lg">
              <TopText
                ctmarketlist={ctmarketlist}
                setIsShowCoin={setIsShowCoin}
                nowTab={nowTab}
                coinListData={coinListData}
              />
            </div>

            {nowTab && (
              <div className="bg-neutral-800 rounded-lg mx-2 mb-2 flex-grow shadow-lg overflow-hidden">
                <KineCenter
                  ctmarketlist={ctmarketlist}
                  nowTab={nowTab}
                  setIndex={setIndex}
                  setType={(type) => {
                    setType(type);
                  }}
                  timeindex={timeindex}
                  settimeindex={settimeindex}
                />
              </div>
            )}

            {/* <div className="px-2 mb-16">
        <TopBuy setIsShowOrder={setIsShowOrder} setType={setType} />
      </div>
       */}
          </>
        ) : (
          <div className="container mx-auto grid grid-cols-12 gap-4">
            <div className="col-span-8">
              <div className="w-full">
                <TopBar
                  coinname={param.name}
                  iscollect={iscollect}
                  collectAdd={collectAdd}
                  collectDel={collectDel}
                />
              </div>

              <div className="bg-neutral-800 rounded-lg mx-2 my-2 shadow-lg">
                <TopText
                  ctmarketlist={ctmarketlist}
                  setIsShowCoin={setIsShowCoin}
                  nowTab={nowTab}
                  coinListData={coinListData}
                />
              </div>

              {nowTab && (
                <div className="bg-neutral-800 rounded-lg mx-2 mb-2 flex-grow shadow-lg overflow-hidden">
                  <KineCenter
                    ctmarketlist={ctmarketlist}
                    nowTab={nowTab}
                    setIndex={setIndex}
                    setType={(type) => {
                      setType(type);
                    }}
                    timeindex={timeindex}
                    settimeindex={settimeindex}
                  />
                </div>
              )}

              {/* <div className="px-2 mb-16">
        <TopBuy setIsShowOrder={setIsShowOrder} setType={setType} />
      </div>
       */}
            </div>
            <div className="col-span-4">
              <div className="bg-neutral-800 rounded-lg p-4 mt-4">
                <div className="flex justify-between items-center mb-4">
                  <p className="text-white text-lg font-bold">
                    {translate(getText("訂單確認"))}
                  </p>
                </div>

                <div className="bg-neutral-700 rounded-lg p-4 mb-4">
                  <div className="flex justify-between items-center mb-3">
                    <p className="text-neutral-400">
                      {translate(getText("名稱"))}
                    </p>
                    <p className="text-white font-semibold">
                    {(() => {
                      const findCoinData = ctmarketlist.find(v => v.coinname === nowTab)
                      const showName = findCoinData?.type === 2 ? findCoinData?.issueName : nowTab
                      return showName?.toUpperCase();
                    })()}
                      <span className="text-neutral-400 ml-1">/USDT</span>
                    </p>
                  </div>
                  <div className="flex justify-between items-center mb-3">
                    <p className="text-neutral-400">
                      {translate(getText("方向"))}
                    </p>
                    <div className="flex gap-2">
                      <button
                        className={`transition-all px-4 py-2 rounded ${
                          type === 1
                            ? "bg-green-600 text-black"
                            : "bg-neutral-600 text-neutral-300"
                        }`}
                        onClick={() => setType(1)}
                      >
                        {translate(getText("看漲"))}
                      </button>
                      <button
                        className={`transition-all px-4 py-2 rounded ${
                          type === 2
                            ? "bg-red-600 text-black"
                            : "bg-neutral-600 text-neutral-300"
                        }`}
                        onClick={() => setType(2)}
                      >
                        {translate(getText("看跌"))}
                      </button>
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <p className="text-neutral-400">
                      {translate(getText("現價"))}
                    </p>
                    <p className="text-white font-semibold">
                      {coinListData[nowTab]?.close}
                    </p>
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-neutral-200 font-medium mb-2">
                    {translate(getText("請選擇時間"))}
                  </p>
                  <div className="overflow-x-auto">
                    <div className="flex flex-wrap gap-2">
                      {(hysetInfo as any)?.hyTime?.map(
                        (time: string, index: number) => (
                          <div
                            key={index}
                            className={
                              timeindex === index + 1
                                ? "bg-primary/90 text-black rounded-lg p-2.5 flex flex-col items-center w-[80px] cursor-pointer"
                                : "bg-neutral-700 text-neutral-200 rounded-lg p-2.5 flex flex-col items-center border border-neutral-600 w-[80px] cursor-pointer"
                            }
                            onClick={() => {
                              settimeindex(index + 1);
                            }}
                          >
                            <div className="text-sm font-semibold">{time}</div>
                            <div className="text-xs mt-1">
                              {(hysetInfo as any)?.hyYkbl?.[index]}%
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>

                <div className="mb-6">
                  <div className="mb-2">
                    <p className="text-neutral-200 font-medium mb-1">
                      {translate(getText("買入數量"))}
                    </p>
                  </div>
                  <div className="mb-2">
                    <input
                      id="pcBuyAmount"
                      placeholder={translate(getText("最少10起買")).replace(
                        "10",
                        (hysetInfo as any)?.hyTzed?.[timeindex - 1] || 100
                      )}
                      className="w-full h-[45px] px-4 py-3 rounded bg-neutral-800/80 text-white focus:outline-none text-sm"
                      type="number"
                      min={(hysetInfo as any)?.hyTzed?.[timeindex - 1] || 100}
                      step="0.01"
                      onChange={(e) => {
                        const value = parseFloat(
                          parseFloat(e.target.value).toFixed(2)
                        );
                        if (
                          e.target.value &&
                          (hysetInfo as any)?.hyYkbl?.[timeindex - 1]
                        ) {
                          setyqsy(
                            value *
                              (hysetInfo as any).hyYkbl[timeindex - 1] *
                              0.01
                          );
                        } else {
                          setyqsy(0);
                        }
                      }}
                    />
                  </div>
                  <div className="flex justify-between">
                    <p className="text-neutral-400 text-sm">
                      {translate(getText("可用餘額"))}:{userInfo?.usdt || 0}
                    </p>
                  </div>
                </div>

                <div>
                  <button
                    className="w-full h-[45px] rounded bg-gradient-primary text-black font-bold flex items-center justify-center text-base cursor-pointer"
                    onClick={() => {
                      const minNum =
                        (hysetInfo as any)?.hyTzed?.[timeindex - 1] || 100;
                      const inputElement = document.getElementById(
                        "pcBuyAmount"
                      ) as HTMLInputElement;
                      const value = parseFloat(inputElement?.value || "0");

                      if (value < minNum) {
                        Toast.show({
                          content: `${translate(
                            getText("最低投資額")
                          )} ${minNum}`,
                        });
                        return;
                      }

                      buyCoin({
                        ccoinname: `${nowTab?.toUpperCase()}/USDT`,
                        ctzed: value,
                        ctzfx: type,
                        ctime: (hysetInfo as any)?.hyTime?.[
                          timeindex - 1
                        ]?.toUpperCase(),
                        cykbl: (hysetInfo as any)?.hyYkbl?.[timeindex - 1],
                      });
                    }}
                  >
                    {translate(getText("確認下單"))}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 左边弹框  */}
        <CoinPopup
          isShowCoin={isShowCoin}
          setIsShowCoin={setIsShowCoin}
          coinListData={coinListData}
          ctmarketlist={ctmarketlist}
          collectlist={collectlist}
          index={2}
        />
        {/* 订单底部弹框 */}
        <OrderPopup
          type={type}
          setyqsy={setyqsy}
          setType={setType}
          userInfo={userInfo}
          hysetInfo={hysetInfo}
          buyCoin={buyCoin}
          isShowOrder={isShowOrder}
          setIsShowOrder={setIsShowOrder}
          nowTab={nowTab}
          coinListData={coinListData}
          ctmarketlist={ctmarketlist}
          index={1}
        />

        {/* 倒计时 */}
        <CenterPopup
          visible={visible}
          destroyOnClose={true}
          onMaskClick={() => {
            setVisible(false);
          }}
        >
          <DaoJiShi
            userInfo={userInfoData}
            // yqsy={yqsy}
            setVisible={setVisible}
            coinListData={coinListData}
            daojis={daojishi}
            nowTab={nowTab}
            sendData={sendData}
            hysetInfo={hysetInfo}
            companyData={companyData}
            successOrderNo={successOrderNo}
          />
        </CenterPopup>
      </AcendexLayout>
    </div>
  );
}
